import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';

import PostLogImportRecordsAPI from 'api/postLogImportRecordsAPI';

import { useToast } from 'context/ToastContext';

import { ToastType } from 'constants/enums/PopupType';

interface Props {
  recordId: number;
  fileName: string;
  hasIssues: boolean;
}

const ExceptionsCell = ({ recordId, fileName, hasIssues }: Props) => {
  const { onToastOpen } = useToast();

  if (!hasIssues) return null;

  const onClick = async () => {
    const response = await PostLogImportRecordsAPI.downloadExceptions(recordId);
    const blob = response?.data;
    const isCsvBlob =
      blob instanceof Blob &&
      (blob.type === 'text/csv' || blob.type === '' || blob.type === 'application/octet-stream');
    if (!blob || (blob instanceof Blob && !isCsvBlob)) {
      onToastOpen(
        `post-log-download-error-${recordId}`,
        'Failed to download exceptions file.',
        ToastType.error
      );
      return;
    }
    const csvBlob = blob instanceof Blob ? blob : new Blob([blob], { type: 'text/csv' });
    const url = URL.createObjectURL(csvBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `exceptions-${fileName}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <IconButton data-testid="post-log-exceptions-download" onClick={onClick} size="small">
      <DownloadIcon />
    </IconButton>
  );
};

export default ExceptionsCell;
